import {makeStyles} from "@material-ui/core";


export default makeStyles(theme => ({
  root: {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    color: "white",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      display: "flex"
    },
    [theme.breakpoints.up("md")]: {
      display: "none !important",
    },
    "& button.Mui-selected":{
      color: "#FFFFFF",
      backgroundColor: "#8585853d"
    }
  },
}));